/* src/app/modules/agendapro/agendapro.component.css */
.calendar-wrapper {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
  margin: 2rem auto;
}
.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem 1rem;
  border-bottom: 1px solid #e8e8e8;
}
.calendar-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1f1f1f;
  text-transform: capitalize;
}
.header-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}
.btn-nav {
  background: #f3f4f6;
  border: none;
  color: #222;
  font-weight: 500;
  border-radius: 6px;
  padding: 6px 10px;
  transition: background 0.2s;
}
.btn-nav:hover {
  background: #e5e7eb;
}
.btn-today {
  background: var(--cf-brand-dark);
  color: white;
  border-radius: 6px;
  border: none;
  padding: 6px 12px;
  font-weight: 500;
  transition: background 0.2s;
}
.btn-today:hover {
  background: #d88714;
}
.view-switch {
  display: flex;
  align-items: center;
  background: #1f2937;
  border-radius: 6px;
  overflow: hidden;
}
.view-switch button {
  background: none;
  border: none;
  color: white;
  font-weight: 500;
  padding: 6px 12px;
  transition: background 0.2s;
}
.view-switch button.active {
  background: var(--cf-brand-dark);
  color: #fff;
}
.view-switch button:hover {
  background: #374151;
}
::ng-deep .cal-event {
  background: var(--cf-brand-dark) !important;
  border: none !important;
  border-radius: 3px;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 2px 4px !important;
}
::ng-deep .cal-day-cell.cal-today {
  background: #fff8e1 !important;
  border: 2px solid var(--cf-brand-dark) !important;
}
::ng-deep .cal-day-number {
  font-weight: 600 !important;
  color: #2e2e2e !important;
}
::ng-deep .cal-header {
  background: #f9fafb !important;
  color: #444;
  font-weight: 600;
  border-radius: 10px 10px 0 0;
}
::ng-deep mwl-calendar-month-view,
::ng-deep mwl-calendar-week-view,
::ng-deep mwl-calendar-day-view {
  border-radius: 10px;
}
::ng-deep .cal-day-cell {
  border-color: #f0f0f0 !important;
}
@media (max-width: 768px) {
  .calendar-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
.view-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  background: #fff;
  border-radius: 12px;
  padding: 10px 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.view-title mat-icon {
  color: var(--cf-brand-dark);
}
::ng-deep .cal-event {
  display: flex;
  align-items: center;
  background: #fff5e6 !important;
  border: 1px solid var(--cf-brand-dark) !important;
  border-left: 5px solid var(--cf-brand-dark) !important;
  border-radius: 8px !important;
  padding: 6px 10px !important;
  margin-bottom: 4px !important;
  color: #2b2b2b !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::ng-deep .cal-event:hover {
  background: var(--cf-brand-dark) !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(236, 151, 31, 0.3);
}
::ng-deep .cal-event-title {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
::ng-deep .cal-day-cell.cal-today {
  background: #fffaf3 !important;
  border: 2px solid var(--cf-brand-dark) !important;
  border-radius: 10px;
}
::ng-deep .custom-event {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  line-height: 1.2;
}
::ng-deep .custom-event .event-title {
  font-weight: 600;
  color: #2d2d2d;
}
::ng-deep .custom-event .event-desc {
  color: #555;
  font-size: 12px;
  opacity: 0.9;
}
::ng-deep .custom-month-event,
::ng-deep .cal-event {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #fff5e6 !important;
  border: 1px solid var(--cf-brand-dark) !important;
  border-left: 5px solid var(--cf-brand-dark) !important;
  border-radius: 8px !important;
  padding: 4px 8px !important;
  margin-bottom: 4px !important;
  color: #2b2b2b !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease-in-out;
  overflow: hidden;
}
::ng-deep .custom-month-event:hover,
::ng-deep .cal-event:hover {
  background: var(--cf-brand-dark) !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(236, 151, 31, 0.25);
}
::ng-deep .custom-month-event .contact,
::ng-deep .cal-event .contact {
  font-weight: 600;
  font-size: 13px;
  color: #1f1f1f;
  margin-bottom: 2px;
}
::ng-deep .custom-month-event .title,
::ng-deep .cal-event .title {
  font-size: 12px;
  color: #444;
  opacity: 0.9;
}
::ng-deep .cal-week-view .cal-event,
::ng-deep .cal-day-view .cal-event {
  border-radius: 8px !important;
  padding: 6px 8px !important;
  font-size: 12px !important;
  white-space: normal !important;
  line-height: 1.2 !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
::ng-deep .cal-day-cell.cal-today {
  background: #fffaf3 !important;
  border: 2px solid var(--cf-brand-dark) !important;
  border-radius: 10px;
}
::ng-deep .custom-event {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #fff5e6 !important;
  border: 1px solid var(--cf-brand-dark) !important;
  border-left: 5px solid var(--cf-brand-dark) !important;
  border-radius: 8px !important;
  padding: 6px 10px !important;
  margin-bottom: 4px !important;
  color: #2b2b2b !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease-in-out;
}
::ng-deep .custom-event:hover {
  background: var(--cf-brand-dark) !important;
  color: white !important;
  transform: translateY(-2px);
}
::ng-deep .custom-event .contact {
  font-weight: 600;
  font-size: 13px;
  color: #1f1f1f;
  margin-bottom: 2px;
}
::ng-deep .custom-event .title {
  font-size: 12px;
  color: #555;
  opacity: 0.9;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.modal {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: auto;
  max-width: 500px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  overflow-y: auto;
  max-height: 90vh;
  z-index: 2001;
  animation: fadeIn 0.3s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.modal h2 {
  margin-top: 0;
  font-size: 20px;
  color: #333;
}
.modal form label {
  display: block;
  margin-top: 10px;
  font-weight: bold;
  color: #444;
}
.modal form input,
.modal form textarea,
.modal form select {
  width: 100%;
  padding: 8px;
  margin-top: 4px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.modal-buttons {
  margin-top: 20px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.modal-buttons button {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}
.modal-buttons button[type=submit] {
  background-color: #e3fd64;
  color: #1a1d23;
}
.modal-buttons button[type=button] {
  background-color: #ccc;
  color: #333;
}
@media (max-width: 768px) {
  .calendar-main {
    width: 95vw;
    height: 90vh;
    padding: 10px;
  }
  #calendar {
    padding: 0;
    height: 100%;
  }
  .btn-nuevo-evento {
    font-size: 14px;
    padding: 8px 12px;
  }
  .modal {
    max-width: 100%;
    padding: 15px;
  }
  .modal-buttons {
    flex-direction: column;
    gap: 8px;
  }
  .modal-buttons button {
    width: 100%;
  }
}
.event-form {
  display: flex;
  flex-direction: column;
}
.full-width {
  width: 100%;
  margin-bottom: 1rem;
}
.date-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
.half-width {
  flex: 1 1 45%;
  min-width: 200px;
}
mat-dialog-actions,
.mat-mdc-dialog-actions {
  margin-top: 1.5rem;
}
.row-fields {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.half-width {
  flex: 1 1 0;
  min-width: 200px;
}
.side-panel {
  width: 400px;
  height: 100vh;
  position: fixed;
  right: 0;
  top: 0;
  background: #fff;
  border-left: 1px solid #e5e5e5;
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  font-family:
    "Inter Tight",
    "Segoe UI",
    Roboto,
    sans-serif;
  animation: slideIn 0.3s ease-out;
}
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 1.5rem;
  border-bottom: 1px solid #f0f0f0;
}
.dialog-header h2 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
}
.close-btn {
  background: none;
  border: none;
  font-size: 1.6rem;
  cursor: pointer;
  color: #888;
  transition: color 0.2s;
}
.close-btn:hover {
  color: #000;
}
.dialog-content {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;
}
.info-block p {
  margin: 0.4rem 0;
  font-size: 0.95rem;
  color: #444;
}
.info-block .label {
  font-weight: 600;
  color: #555;
}
hr {
  border: none;
  border-top: 1px solid #eee;
  margin: 1.5rem 0;
}
.actions {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}
.btn {
  border: none;
  border-radius: 6px;
  padding: 0.6rem 1rem;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}
.btn.primary {
  background-color: #007bff;
  color: white;
}
.btn.primary:hover {
  background-color: #0069d9;
}
.btn.danger {
  background-color: #f44336;
  color: white;
}
.btn.danger:hover {
  background-color: #d32f2f;
}
.btn.secondary {
  background-color: #f5f5f5;
  color: #444;
}
.btn.secondary:hover {
  background-color: #e0e0e0;
}
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.appointment-form {
  padding-bottom: 4rem;
}
.footer-actions {
  position: sticky;
  bottom: 0;
  z-index: 10;
}
mat-form-field {
  font-size: 0.95rem;
}
mat-form-field .mat-mdc-text-field-wrapper {
  background: #fafafa;
  border-radius: 6px;
}
.footer-actions {
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.05);
}
/*# sourceMappingURL=agendapro.component.css.map */
